import React,{useState,useEffect} from "react";
import './Music.css'
import AlbumExampleImg2 from './../../../../images/albumexampleimg2.png'
import PurpleBackIcon from './../../../../images/purplebackicon.png'
import PinkBackIcon from './../../../../images/pinkbackicon.png'

import playsongicon from './../../../../images/playsongicon.png'
import Nomusicimg from './../../../../images/nomusicimg.png'
import DraftCover from './../../../../images/draftalbumcover.png'
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select'
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {Route,Routes, Redirect, Navigate} from 'react-router-dom'

function AlbumList({dummyalbums,prevPage,shareData}) {
    const [toggledetails,setToggleDetails] = useState(false)
    const [viewoption,setViewOption] = useState({ value: 'All', label: 'All'})
    const [artistName,setArtistName] = useState("Peggy Gou")
    const [labelName,setLabelName] = useState("J.A.C")
    const [genre,setGenre] = useState("R&B")
    const [noMusic,setNoMusic] = useState(true)
    const [releaseDate,setReleaseDate] = useState("Nov 21, 2023")
    const [format,setFormat] = useState()
    const [showtrackdetails,setShowTrackDetails]= useState(false)
    const [albumDraft,setAlbumDraft] = useState([])
    const [albumImg,setAlbumImg] = useState([])
    const [refreshList,setRefreshList] = useState(0)
    const [track,setTrack] = useState({ "trackno":"1",
                                        "trackname":"Echoes of Yesterday",
                                        "label":"J.A.C",
                                        "genre":"R&B",
                                        "releasedate":"Nov 21,2023",
                                        "songwriters":"Peggy Gou",
                                        "producers":"Jonny Greenwood",
                                        "featuredartists":"Thome Yorke",
                                        "explicitcontent":"No",
                                        "instrumental":"No",
                                        "radioedit":"No",
                                        "price":"0.99",
                                        "royaltysplit":[{"Peggy Gou":"60%"},{"Artist Name":"40%"}]})
    const [albumname,setAlbumName] = useState()
   
    const [loading,setLoading] = useState(true)
    const [dimensions, setDimensions] = useState({ 
        height: window.innerHeight,
        width: window.innerWidth
      })
      const formatOptions = [{ value: 'All release', label:'All release' },
      { value: 'Single', label: 'Single' },
      { value: 'Album', label: 'Album' },
      { value: 'EP', label: 'EP' }] 
      const navigate = useNavigate();

      const {t, i18n } = useTranslation();
      const cookies = new Cookies(null ,{ path: '/' });
    
      const changeFormatHandler = value => {
        setFormat(value) 
    }

    const TrackDetailsComplexStyles = {
        control: styles => ({ ...styles,  borderColor: '#636468',
        backgroundColor:'rgba(0,0,0,16%)',
        width: '15em',
        height: '3em',
        marginRight:'1em',
        color:'rgba(255, 255, 255, 1)',
        "&:hover": {
          backgroundColor: "rgba(254,254,254,20%)"
        }
      }),
      menu:  styles => ({ ...styles, 
      color:'rgba(255, 255, 255, 1)',
      borderColor:'#636468',
      width: '15em',
      borderTopLeftRadius:'4px',
      borderTopRightRadius:'4px',
      marginTop:'0.3em',
      border:'0.5px rgba(255,255,255,10%) solid'
     }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:'#2A333D' ,
            color:'rgba(255, 255, 255, 1)',
            cursor: isDisabled ? 'not-allowed' : 'default',
            marginTop:'-0.3em',
            marginBottom:'-0.3em',
            "&:hover": {
              backgroundColor: 'rgba(0,0,0,100%)'
            }
          };
        },
        input: (styles) => ( {...styles , 
                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                FontSize:'1rem',
                                FontWeight: 'medium',
                                LineHeight: '150%',
                                LetterSpacing: '0%',
                                color:'rgba(255, 255, 255, 1)',
                                borderTopLeftRadius:'4px',
                                borderTopRightRadius:'4px',}),
        singleValue : (styles) => ({ ...styles, 
                                        color:'rgba(255, 255, 255, 1)',
                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                        FontSize:'1rem',
                                        FontWeight: 'medium',
                                        LineHeight: '150%',
                                        LetterSpacing: '0%'}),
         hover : styles =>({
                                          backgroundColor:'rgba(255,255,255,8%)',
          }),
          menuList: (base) => ({
            ...base,
        
            "::-webkit-scrollbar": {
              width: "0px",
              height: "0px",
            },
            "::-webkit-scrollbar-track": {
              background: "#f1f1f1"
            },
            "::-webkit-scrollbar-thumb": {
              background: "#888"
            },
            "::-webkit-scrollbar-thumb:hover": {
              background: "#555"
            }
          })
      };

      useEffect(() => {
        function handleResize() {
          setDimensions({
            height: window.innerHeight,
            width: window.innerWidth
          })
        
    }

    
        window.addEventListener('resize', handleResize)
    
        return _ => { 
          window.removeEventListener('resize', handleResize)
        }
      })

      function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    
    useEffect(()=>{
        topFunction()
        if(cookies.get("artistname").length!==0){
            setNoMusic(false)
          }
          if(albumDraft.length===0){
            getProducts()
          }
        
    },[])

    useEffect(()=>{
      console.log("Refreshed list")
      console.log(albumImg)
    },[refreshList])

    useEffect(()=>{
      console.log("Data")
      console.log(albumDraft)
      if(albumDraft.length!==0){
        albumDraft.map((albumItem,index)=>{
          setRefreshList(Math.random())
          if(albumItem.image_url!==undefined){
            getimgfromurl(albumItem.image_url,index)
          }
        })
      }
    },[albumDraft])

    useEffect(()=>{
      // if(albumDraft.length!==0){
      //   var cover= []

      //   albumDraft.map((album,index)=>{
      //     if(album.image_url!==undefined){
      //       getimgfromurl(album.image_url,index,cover)
      //     }else{
      //       cover[index] = null
      //     }
      //   })

      //   setAlbumImg(cover)
      // }
      },[albumDraft])

    useEffect(()=>{
      // if(albumImg.length!==0){
      //   console.log("Album Image Array")
      //   console.log(albumImg.length)
      //   albumImg.map((img,index)=>{
      //     console.log(albumImg[index])
      //   })
      // }
    },[albumImg])

    const changeViewHandler = value => {
        setViewOption(value)
    }

    const getProducts = () =>{
        axios({
            method:'get',
            url:"https://n3rve.fly.dev/products",
            headers:{
                Authorization: "Bearer ".concat(cookies.get("token"))
            }
        }).then(res=>{
          setAlbumDraft(res.data)
          console.log(res)
          // res.data.map((album)=>{
          //   if(album.img_url!==undefined){
          //     console.log(album.img_url)
          //   }
          // })
          var cover= []
          setAlbumImg([])
          res.data.map((album,index)=>{
            if(album.image_url!==undefined){
              getimgfromurl(album.image_url,index)
            }else{
              albumImg[index] = null
            }
          })
          console.log("Value of Array")
          console.log(albumImg)
          console.log(albumImg.length)
          console.log(albumImg[1])
          setRefreshList(Math.random())
          // setAlbumImg(cover)
        }).catch((e)=>{
          console.log(e)
        }).finally(()=>{
            setLoading(false)
        })
    }

    const getimgfromurl  = async (url, index) => {
      try {
        // console.log("Fetching image from URL:", url);
  
        const res = await fetch(url, { mode: 'cors' });
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        
        const contentType = res.headers.get("content-type");
        if (!contentType || !contentType.startsWith("image/")) {
            throw new Error(`Expected image content type but received ${contentType}`);
        }
  
        const blob = await res.blob();
        // console.log("Blob obtained:", blob);
  
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        // console.log("Image source set to:", img.src);
  
        // Newer promise based version of img.onload
        await img.decode();
  
        // console.log("Image decoded successfully");
        // document.body.append(img);
        // MAYBE UNCOMMENT
        // setAlbumImage([blob])
        // cover[index] = [blob]
        // cover.push(blob)
        albumDraft[index].set("image",blob)
      

        // console.log(img)
  
        // Don't forget to revoke the blob URL when 
        // you no longer need it (to release memory)
        URL.revokeObjectURL(img.src);
        // console.log("Blob URL revoked");
    } catch (error) {
        console.error("Error loading image:", error);
    }
    }

    const viewOptions = [{ value: 'All', label: 'All'}]
    const jpviewOptions = [{ value: 'All', label: '全て'}]

    const colourStyles = {
        control: styles => ({ ...styles,  borderColor: '#636468',
        backgroundColor:'#182833',
        width: '10em',
        height: '2.5em',
        borderRadius:'8px',
        color:'rgba(255, 255, 255, 1)',
        marginLeft:'0.5em'
       }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:'#18191F' ,
            color:'rgba(255, 255, 255, 1)',
            cursor: isDisabled ? 'not-allowed' : 'default',
            marginTop:'-0.3em',
            marginBottom:'-0.3em',
            borderRadius:'3px'
          };
        },
        input: (styles) => ( {...styles , 
                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                FontSize:'1rem',
                                FontWeight: 'medium',
                                LineHeight: '150%',
                                LetterSpacing: '0%',
                                color:'rgba(255, 255, 255, 1)'}),
        singleValue : (styles) => ({ ...styles, 
                                        color:'rgba(255, 255, 255, 1)',
                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                        FontSize:'1rem',
                                        FontWeight: 'medium',
                                        LineHeight: '150%',
                                        LetterSpacing: '0%'
                                        }),
        menuList: (base) => ({ ...base,
                                        "::-webkit-scrollbar": {
                                            width: "0px",
                                            height: "0px",
                                        },
                                        "::-webkit-scrollbar-track": {
                                            background: "#f1f1f1"
                                        },
                                        "::-webkit-scrollbar-thumb": {
                                            background: "#888"
                                        },
                                        "::-webkit-scrollbar-thumb:hover": {
                                            background: "#555"
                                            }
                                          })
      };

    return (
        <div  >
            {
                noMusic &&
                <div style={{height:document.body.scrollHeight,display:'flex',flexDirection:'column',alignItems:"center"}}>
                
                <img src={Nomusicimg} style={{height:'16.5em',width:'15em',marginTop:'9.81em',marginBottom:'1.5em'}}/>
                <div className="NoReleaseH1">No Release Yet</div>   
                <div className="NoReleaseH2">Your music will be listed here once you release it. Ready to share your sound with the world? Start your first release now!</div>   
                <div className="ReleaseMusicRedBtn" onClick={()=>navigate("/Dashboard/releasemusic")}>Release Music</div>
                </div>
               
            }
            {
                !noMusic &&
            <div className="MusicContainer" >
            
            {
                !toggledetails && !showtrackdetails &&
                <div style={{display:'flex',flexDirection:'column',width:'100%',alignItems:'center'}}>
                <div className="MusicHeaderMain">MY MUSIC</div>
                <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'flex-end',width:'93.28%',alignSelf:'center',marginTop:'1.5em',borderBottom:'rgba(255,255,255,25%) 0.5px solid',paddingBottom:'1em'}}> 
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                        {/* <div className="TypeTxt">{t('Type:')}</div>
                        <div style={{display:'flex',flexDirection:'column'}}>
                        <div className="Genreheader">{t('Genre')}</div>
                        {
                            cookies.get('lang') === 'en' &&
                            <Select options={viewOptions} value={viewoption} onChange={changeViewHandler} 
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            styles={
                                colourStyles
                            }
                            defaultValue={{ label: "All", value: "All"}}
                        />
                        }
                        {
                            cookies.get('lang') === 'jp' &&
                            <Select options={jpviewOptions} value={viewoption} onChange={changeViewHandler} 
                            components={{
                                IndicatorSeparator: () => null
                            }}
                            styles={
                                colourStyles
                            }
                            defaultValue={{ label: "All", value: "All"}}
                        />
                        }
                       
                        </div> */}
                    </div>
                    
                    <Select options={formatOptions} value={format}  onChange={changeFormatHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="All release"
                    isSearchable
                    styles={
                      TrackDetailsComplexStyles
                    }
                    />

                    <div className="ReleaseMusicBtn" onClick={()=>navigate("/Dashboard/releasemusic")} style={{marginTop:'0em'}}> 
                       + {t('Releasemusic')}
                       <div className="PostLoginBtnOverlay"/>
                    </div>
                </div>

                <div className="AlbumsContainer">
                    <div className="AlbumTxt">{t('Album')}</div>
                    <div style={{display:'flex',flexDirection:'row', marginLeft:'1em',paddingRight:'2.5em',paddingTop:'1.8em',paddingBottom:'2.5em',flexWrap:'wrap'}}>

                    {
                        dummyalbums.map((album)=>{
                            return (
                            <div className="AlbumCard" onClick={()=>{navigate("/Dashboard/music/albumdetails",{state:{album:album}})}}>
                                <img src={album.image} alt="Album Cover Img" className="AlbumCover"/>
                                <div className="AlbumTitle">{t('Album')}</div>
                                <div className="AlbumName">{album.name}</div>
                                <div className="AlbumDate">{t('Releasedate')} : {album.releasedate}</div>
                                {
                                album.status==="RELEASED" &&
                                 <div className="AlbumStatus" style={{color:'#60E5C5'}}>{album.status}</div>
                                }

                                {
                                album.status==="PENDING" &&
                                 <div className="AlbumStatus">{album.status}</div>
                                }
                               
                            </div>
                            )
                        })
                    }
                    {/* <div className="AlbumCard" onClick={()=>{setToggleDetails(!toggledetails); setAlbumName("Don't Waste A Minute")}}>
                        <img src={AlbumExampleImg2} alt="Album Cover Img" className="AlbumCover"/>
                        <div className="AlbumTitle">{t('Album')}</div>
                        <div className="AlbumName">Don't Waste A Minute</div>
                        <div className="AlbumDate">{t('Releasedate')} : August 31,2023</div>
                        <div className="AlbumStatus" style={{color:'#60E5C5'}}>{t('Releasedstatus')}</div>
                    </div>

                    <div className="AlbumCard" onClick={()=>{setToggleDetails(!toggledetails); setAlbumName("Vivid Reflection")}}>
                        <img src={AlbumExampleImg} alt="Album Cover Img" className="AlbumCover"/>
                        <div className="AlbumTitle">{t('Album')}</div>
                        <div className="AlbumName">Vivid Reflection</div>
                        <div className="AlbumDate">{t('Releasedate')} : August 31,2023</div>
                        <div className="AlbumStatus">{t('Pendingstatus')}</div>
                    </div> */}
                    
                    {
                        loading &&
                        <CircularProgress style={{position:'fixed',width:'5em',height:'5em',marginLeft:'45%',marginTop:'4em'}} sx={{color:'#FFFFFF'}}/>
                    }
                    

                    {
                        albumDraft.map((item,index)=>{
                            
                            return (
                            <div className="AlbumCard" onClick={()=>{prevPage("Music");shareData(item);navigate("/Dashboard/releasemusic")}}>
                              {
                                item.image_url=== undefined &&
                                <img src={DraftCover} alt="Album Cover Img" className="AlbumCover"/>
                              } 

                            {
                                item.image_url!== undefined &&
                                <img src={item.image_url} alt="Album Cover Img" className="AlbumCover"/>
                              }   

                              {/* {
                                item.image_url!== undefined &&
                                <img src={URL.createObjectURL(item.image)} alt="Album Cover Img" className="AlbumCover"/>
                              }    */}
                                
                                 {/* <img src={DraftCover} alt="Album Cover Img" className="AlbumCover"/> */}
                                <div className="AlbumTitle">{t('Album')}</div>
                                {
                                    item.details===undefined &&
                                    <div className="AlbumName">Untitled</div>
                                }
                                {
                                    item.details!==undefined &&
                                    <div className="AlbumName">{item.details.name}</div>
                                }
                                
                                <div className="AlbumStatus">DRAFT</div>
                            </div>
                            )
                        })
                    }

                    </div>
                </div>


                </div>  
            }
            </div>
            }
            
        </div>
        
    );
}

export default AlbumList;